import React from "react";
import jsDig from "utils/jsDig";
import PDFPage from "pdfs/PDFPage";

export default function MonthlyReportIntro(props) {
  const datapulseLogo = require("images/logos/datapulse-logo-blue.png");
  const ppcEnabled = jsDig(["search_section", "enabled"], props) || jsDig(["social_section", "enabled"], props) || jsDig(["display_section", "enabled"], props) || jsDig(["video_section", "enabled"], props)
  const seoEnabled = jsDig(["seo_section", "enabled"], props)

  return (
    <PDFPage pageNumber={1} hideLogo={props.white_label_service}>
      <h1>
        <img src={`/datapulse${datapulseLogo}`} style={{ width: "60%", marginTop: "15%" }} />
      </h1>
      <h1 style={{ fontSize: "80px", padding: "40px" }}>{props.client_name}</h1>
      <h6 style={{ textAlign: "center" }}>Performance Snapshot for</h6>
      <h2 style={{ textAlign: "center" }}>{props.date_formatted}</h2>
      <div className="pdf-intro-box pb-4">
        <p className="px-3 pt-4">In this reivew, we'll walk through {props.date_formatted}'s performance in regard to:</p>
        {ppcEnabled && (
          <>
            <h6 className="px-3 ppc-performance"> PPC Performance</h6>
            <ul className="pdf-ppc-list">
              <li>KPI's vs. Goals</li>
              <li>Overview of all PPC performance</li>
              <li>Overview of PPC sub-services</li>
            </ul>
          </>
        )}
        {seoEnabled && (
          <>
            <h6 className="px-3 seo-performance">SEO Performance</h6>
            <ul className="pdf-seo-list">
              <li>Overview of all SEO performance</li>
            </ul>
          </>
        )}
      </div>
    </PDFPage>
  );
}
